// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2ew9J","list":"styles_list__G6wcZ"};